<template>
  <v-card outlined :loading="loading">
    <div class="pa-2">
      <v-tabs v-model="tab">
        <v-tab v-for="item in languages" :key="item.id">
          {{ item.name }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item v-for="item in languages" :key="item.id">
          <v-card v-if="localappcontent" ref="tabItem" flat min-height="100">
            <app-content-tab-item
              v-model="localappcontent"
              :language-id="item.id"
              :form-path="formPath"
            >
            </app-content-tab-item>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </v-card>
</template>

<script>
import { cloneDeep } from 'lodash';

export default {
  name: 'AppContentForm',
  components: {
    AppContentTabItem: () =>
      import('@/modules/app_content/components/AppContentTabItem.vue')
  },

  model: {
    prop: 'appContent'
  },

  props: {
    formPath: {
      type: String,
      required: true
    },
    appContent: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      minHeight: 0,
      languages: [
        { id: 1, name: 'Deutsch', locale: 'de' },
        {
          id: 2,
          name: 'English',
          locale: 'en'
        },
        { id: 3, name: 'Fran\u00e7ais', locale: 'fr' },
        { id: 4, name: 'Italiano', locale: 'it' }
      ],

      tab: null,
      localappcontent: {}
    };
  },

  computed: {
    loading() {
      return this.$store.getters['loading'];
    }
  },

  watch: {
    appContent: {
      deep: true,
      handler() {
        if (
          JSON.stringify(this.appContent) ===
          JSON.stringify(this.localappcontent)
        ) {
          return;
        }
        this.setData();
      }
    },
    localappcontent: {
      deep: true,
      handler: 'setAppContent'
    }
  },

  updated() {
    this.setMinHeight();
  },

  created() {
    this.setData();
  },

  methods: {
    setMinHeight() {
      if (
        typeof this.$refs.tabItem !== 'undefined' &&
        this.$refs.tabItem[0].$el.clientHeight
      ) {
        this.minHeight = this.$refs.tabItem[0].$el.clientHeight;
      }
    },
    setAppContent() {
      this.$emit('input', Object.assign({}, this.localappcontent));
    },
    setData() {
      this.localappcontent = cloneDeep(this.appContent);
    }
  }
};
</script>
